import ArialSVGIcon from './arial-icon.svg';
import BahnschriftSVGIcon from './bahnschrift-icon.svg';
import CalibriSVGIcon from './calibri-icon.svg';
import CenturyGothicSVGIcon from './century-gothic-icon.svg';
import ComicSansMSSVGIcon from './comic-sans-ms-icon.svg';
import ConsolasSVGIcon from './consolas-icon.svg';
import GaramondSVGIcon from './garamond-icon.svg';
import GeorgiaSVGIcon from './georgia-icon.svg';
import GillSansMTSVGIcon from './gill-sans-mt-icon.svg';
import ImpactSVGIcon from './impact-icon.svg';
import LucidaSansSVGIcon from './lucida-sans-icon.svg';
import SegoeUISVGIcon from './segoe-ui-icon.svg';
import TahomaSVGIcon from './tahoma-icon.svg';
import TimesNewRomanSVGIcon from './times-new-roman-icon.svg';
import TrebuchetMSSVGIcon from './trebuchet-ms-icon.svg';
import VerdanaSVGIcon from './verdana-icon.svg';

export const SupportedFontsSVGIcons = {
  Arial: ArialSVGIcon,
  Bahnschrift: BahnschriftSVGIcon,
  Calibri: CalibriSVGIcon,
  'Century Gothic': CenturyGothicSVGIcon,
  'Comic Sans MS': ComicSansMSSVGIcon,
  Consolas: ConsolasSVGIcon,
  Garamond: GaramondSVGIcon,
  Georgia: GeorgiaSVGIcon,
  'Gill Sans MT': GillSansMTSVGIcon,
  Impact: ImpactSVGIcon,
  'Lucida Sans': LucidaSansSVGIcon,
  'Segoe UI': SegoeUISVGIcon,
  Tahoma: TahomaSVGIcon,
  'Times New Roman': TimesNewRomanSVGIcon,
  'Trebuchet MS': TrebuchetMSSVGIcon,
  Verdana: VerdanaSVGIcon,
};
